import {
  EmptyInput,
  InputGroup,
  InputRow,
  RadioYesNoInput,
  ModelMultiSelect,
  ModelTextarea,
  SVGInfo,
  useIsUserAuth,
} from '@equifinance/shared';
import { css } from 'styled-components';
import { Stages } from '../../../../types/Stages';
import {
  Applicant, SupportTypes,
} from '../../../../contexts/account/Account';
import { useAccountContext } from '../../../../contexts';
import Section from '../../components/Section';

const multiSelectCss = css`${({ theme }) => `
  .dropdown-container, .multi-select-parent {
    height: auto;
  }
  .dropdown-container {
    padding: ${theme.padding[1]} 0;

    .dropdown-heading {
      padding-top: 0;
      padding-bottom: 0;
      align-items: start;
    }
    .selected-count, .clear-selected-button {
      margin-top: ${theme.padding[2]};
    }
    .list-selected-options {
      flex-wrap: wrap;
    }
    .selected-option-label {
      max-width: none;
    }
    .selected-container {
      align-items: start;
    }
  }
`}`;

export default function AdditionalSupport({
  applicant,
  applicantIndex,
}: {
  applicant: Applicant,
  applicantIndex: number,
}) {
  const { account } = useAccountContext();

  const {
    stage,
  } = account;

  const isExternalUser = useIsUserAuth();
  const disabled = stage !== Stages.Packaging && isExternalUser;

  return (
    <Section
      id={applicant?.additionalSupportDetails?.id}
      title="Additional support"
      level={1}
      titleIcon={<></>}
    >

      <SVGInfo>
        <>By sharing this sensitive information with Equifinance you confirm that you have obtained explicit consent from the Applicant. </>
        <br />
        <>Equifinance may request evidence of this consent at a later date.</>
      </SVGInfo>

      <InputGroup>
        <InputRow>
          <RadioYesNoInput
            label={<>During your interaction with the Applicant(s), are they in need of any additional support to fully understand their proposed loan and future ongoing commitment?</>}
            field={`applicants[${applicantIndex}].requiresAdditionalSupport`}
            required
            disabled={disabled}
          />
        </InputRow>

        {applicant?.requiresAdditionalSupport && (
          <>
            <InputRow>
              <ModelMultiSelect
                label="Support type"
                field={`applicants[${applicantIndex}].additionalSupportDetails.supportTypes`}
                options={SupportTypes}
                containerCss={multiSelectCss}
                required
                disabled={disabled}
              />
              <EmptyInput />
            </InputRow>

            <InputRow>
              <ModelTextarea
                label="Provide support type details"
                field={`applicants[${applicantIndex}].additionalSupportDetails.supportTypeDetails`}
                required
                disabled={disabled}
                rows={0}
                minHeight={62}
                maxHeight={140}
              />
            </InputRow>
          </>
        )}
      </InputGroup>
    </Section>
  );
}
